import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { hasNavPermission } from './ProtectedRoute';
import { formatISODate } from '../utils/dates';
import '../styles/rowProperties.css';

const num = (v, digits = 0) => (v == null || v === ''
  ? '—'
  : Number(v).toLocaleString('es-EC', { minimumFractionDigits: digits, maximumFractionDigits: Math.max(digits, 4) }));
const money = (v) => (v == null || v === '' || Number(v) === 0 ? 'Sin precio' : `$${num(v, 2)}`);

// "Venta #40" chip in a table that opens a small window with that sale's details (Historial de
// Remisiones, under the Hacienda). `sale` is the API's sale (SaleSerializer, e.g. a remisión's
// sale_detail); prices only come for users who can see them. "Abrir venta" for users with Ventas.
export default function SaleDetails({ sale }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  if (!sale?.id) return '—';
  const rows = [
    ['Fecha', `${formatISODate(sale.date)} · Sem ${sale.week} · ${sale.day}`],
    ['Empresa', sale.company_name],
    ['Hacienda', `${sale.farm_name}${sale.magap ? ` · MAGAP ${sale.magap}` : ''}`],
    ['Exportadora', sale.exporter_name],
    ['Marca', sale.brand_name],
    ['Tipo de caja', sale.box_type_name || '—'],
    ['Transporte', sale.transportation_name],
    ['Cajas', num(sale.boxes)],
    ['Pallets', num(sale.pallets)],
    ['Peso caja', `${num(sale.fruit_weight)} lbs`],
    ...('price' in sale ? [['Precio 43 lbs', money(sale.price)], ['Precio real', money(sale.real_price)]] : []),
    ...(sale.comment ? [['Comentario', sale.comment]] : []),
    ['Registrado por', sale.created_by_username || '—'],
  ];

  return (
    <>
      <button
        type="button"
        className="sale-details-link"
        onClick={() => setOpen(true)}
        title="Ver los detalles de la venta"
      >
        🧾 Venta #{sale.id}
      </button>
      {open && (
        <div className="row-props-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) setOpen(false); }}>
          <div className="row-props-dialog sale-details-dialog" role="dialog" aria-modal="true" aria-label={`Venta #${sale.id}`}>
            <div className="row-props-header">
              <div>
                <div className="row-props-title">Venta #{sale.id}</div>
                <div className="row-props-subtitle">{sale.farm_name} · {sale.exporter_name}</div>
              </div>
              <button type="button" className="row-props-close" onClick={() => setOpen(false)} aria-label="Cerrar">✖️</button>
            </div>
            <dl className="row-props-list">
              {rows.map(([label, value]) => (
                <div key={label} className="row-props-row">
                  <dt>{label}</dt>
                  <dd>{value}</dd>
                </div>
              ))}
            </dl>
            {hasNavPermission(user, 'ventas') && (
              <div className="sale-details-footer">
                <Link to={`/ventas/formulario/${sale.id}`} className="sale-details-open">✏️ Abrir venta</Link>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
